import { StyleSheet } from 'react-native';
const styles = StyleSheet.create({
    agendaItemTypeTag: { borderRadius: 100, paddingHorizontal: 20 },
    additionalInformationContainer: {
        width: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center',
        paddingTop: 10,
        paddingBottom: 4,
    },
});
export default styles;
